import React from 'react';
import cl from './Home.module.css';
import HomeInfo from './HomeInfo/HomeInfo';
import Product from '../Products/Product/Product';

const Home = (props) => {
  let featuredProducts = (p) => {
    if (props.productsData.indexOf(p) < 6) {
      return (
        <Product
          onAdd={props.onAdd}
          productId={p.productId}
          name={p.name}
          images={p.images}
          oldPrice={p.oldPrice}
          currency={p.currency}
          discount={p.discount}
          path={'products/' + p.path}
        />
      );
    }
  };

  let productElements = props.productsData.map((p) => featuredProducts(p));

  return (
    <section className={cl.app_about}>
      <HomeInfo
        shopName={props.aboutData.shopName}
        message={props.aboutData.message}
      />
      <div>
      
        <div className={cl.about_products}>{productElements}</div>
      </div>
      <div></div>
    </section>
  );
};

export default Home;
